import { Box, Typography, IconButton } from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function ListPagination({
  page,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
}) {
  if (!totalItems || totalItems <= 0) {
    return null;
  }

  const safePage = Math.min(Math.max(0, page), Math.max(0, totalPages - 1));
  const showingFrom = safePage * pageSize + 1;
  const showingTo = Math.min((safePage + 1) * pageSize, totalItems);

  const maxButtons = 5;
  let start = Math.max(0, safePage - Math.floor(maxButtons / 2));
  const end = Math.min(totalPages, start + maxButtons);
  start = Math.max(0, end - maxButtons);
  const pageNumbers = [];
  for (let i = start; i < end; i += 1) {
    pageNumbers.push(i);
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      mt={2}
      pt={1}
      borderTop={`1px solid ${themeColorsDesingSystem.stone.main}`}
    >
      <Typography
        variant="body2"
        sx={{ color: themeColorsDesingSystem.gray.main }}
      >
        Mostrando {showingFrom}–{showingTo} de {totalItems} registros
      </Typography>
      <Box display="flex" alignItems="center" gap={0.5}>
        <IconButton
          size="small"
          disabled={safePage === 0}
          onClick={() => onPageChange(safePage - 1)}
          aria-label="página anterior"
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        {pageNumbers.map((pageIndex) => (
          <Box
            key={pageIndex}
            component="button"
            type="button"
            onClick={() => onPageChange(pageIndex)}
            sx={{
              minWidth: 32,
              height: 32,
              border:
                pageIndex === safePage
                  ? "none"
                  : `1px solid ${themeColorsDesingSystem.stone.main}`,
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "0.85rem",
              bgcolor:
                pageIndex === safePage
                  ? themeColorsDesingSystem.primary.main
                  : themeColorsDesingSystem.white.main,
              color:
                pageIndex === safePage
                  ? themeColorsDesingSystem.white.main
                  : themeColorsDesingSystem.primary.main,
            }}
          >
            {pageIndex + 1}
          </Box>
        ))}
        <IconButton
          size="small"
          disabled={safePage >= totalPages - 1}
          onClick={() => onPageChange(safePage + 1)}
          aria-label="próxima página"
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
